import { useEffect, useMemo, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { SelectModalityNewSer } from "../../../../contract/select/SelectModalityNewSer";
import { SelectHiringModalityStage } from "./Componentes/SelectHiringModalityStage";
import { _AdquisitionItem, _HiringDocumentStage, _ProcedureImp, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { Alert } from "../../../../theme/Component/Alert";
import { _ContractFiles } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import useModal, { MODAL_md, MODAL_SM, MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { FileService } from "../../../../../core/services/FileService";
import { Modal } from "../../../../theme/Component/Modal";
import { FileInput } from "../../../../theme/Component/FileInput";
import { VisorAnyDocument } from "../../../../documents/VisorAnyDocument";
import { BasicButton } from "../../../../theme/Component/BasicButton";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    IDHiringModality: number;
    IDHiringModalityStage: number;
    Obs: string;
}

export const BPM008 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_HiringDocumentStage);
    const { instance: instanceContrac, lista: listDocs, setLista: setListDocs, bean: beanDoc, setBean: setBeanDoc } = useDataBean(_ContractFiles);
    const { instance: instanceItem, bean: beanItem, setBean: setBeanItem } = useDataBean(_AdquisitionItem);
    const fileService = new FileService();


    const modalAdd = useModal("", MODAL_md);
    const modalDel = useModal("Eliminar Documento Cargado", MODAL_md);

    const [props, setProps] = useState<any>({})
    const [response, setResponse] = useState<Partial<Resp>>({})

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    useEffect(() => {
        if (response.IDHiringModalityStage) {
            getLista()
        }
    }, [response.IDHiringModalityStage])

    useEffect(() => {
        if (props?.IDAdquisitionItem) {
            getListaUploaded();

            instanceItem.getAdquisitionItem(props?.IDAdquisitionItem).then(
                (resp) => {
                    setBeanItem(resp);
                    if (resp.IDHiringModality) {
                        setResponse({ ...response, IDHiringModality: resp.IDHiringModality })
                    }
                }
            ).catch(err => { toast.error(err) })
        }
    }, [props?.IDAdquisitionItem])

    const getLista = () => {
        instance.renderHiringDocumentStage(response.IDHiringModalityStage, 1).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const getListaUploaded = () => {
        instanceContrac.getContractFilesCatalogPorPropiedades({ 'IDAdquisitionItem': props.IDAdquisitionItem, 'State': 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    let tmp = resp;
                    tmp.forEach((element: any) => {
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>VER DOCUMENTO</a>`
                        } else {
                            element.DataBeanProperties.URL = "Sin Documento";
                        }
                    });
                    setListDocs(tmp);
                } else {
                    setListDocs([]);
                }

            }
        )

    }

    const updateDocument = () => {
        instanceContrac.updateContractFiles(beanDoc).then(
            (resp) => {
                toast.success("Documento cargado");
                modalAdd.close();
                setBeanDoc({});
                getListaUploaded();
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const deleteDoc = () => {
        let data = beanDoc;
        data.State = 2;
        instanceContrac.updateContractFiles(data).then(
            (resp) => {
                toast.success("Documento Eliminado");
                modalDel.close();
                setBeanDoc({});
                getListaUploaded();
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )

    }

    const onExportMap = () => {
        const stringList = JSON.stringify(getSlimDocs(listDocs));

        const resumen = listDocs.map((doc, index) => {
            const docData = doc.DataBeanProperties;
            return `${docData.IDContractFiles}. ${docData?.FileName ?? docData?.Media}`;
        }).join("; ");

        if (response.IDHiringModality != beanItem.IDHiringModality) {
            instanceItem.updateAdquisitionItem({ ...beanItem, IDHiringModality: response.IDHiringModality }).then(
                (resp) => {
                    configProcedure?._pushInfo(
                        _single.jsonToBootstrapTable({
                            "Documentos Cargados": resumen,
                        })
                    )
                    configProcedure?._exportMap({
                        Media: stringList,
                        MediaContext: "DocumentExpediente"
                    })
                }
            ).catch((err) => {
                toast.error("No se pudo realizar la acción");
                console.error(err);
            })
        } else {

            configProcedure?._pushInfo(
                _single.jsonToBootstrapTable({
                    "Documentos Cargados": resumen,
                })
            )
            configProcedure?._exportMap({
                Media: stringList,
                MediaContext: "DocumentExpediente"
            })
        }

    }

    const uploadedByRequirementId = useMemo(() => {
        const map = new Map<number, any>();
        (listDocs ?? []).forEach((d: any) => {
            const props = d?.DataBeanProperties;
            if (props?.State === 1) {
                map.set(
                    Number(props.IDHiringDocumentStage),
                    d
                );
            }
        });
        return map;
    }, [listDocs]);

    const canContinue = useMemo(() => {
        if (!lista || lista.length === 0) return false;
        return lista.every((data: any) => {
            const item = data.DataBeanProperties;
            if (item.Optional) return true;
            const reqId = Number(item.IDHiringModalityDocument);
            return uploadedByRequirementId.has(reqId);
        });
    }, [lista, uploadedByRequirementId]);

    const getSlimDocs = (listDocs: any[]) => {
        const newList = listDocs.map(doc => {
            const props = doc?.DataBeanProperties ?? {};
            const uploadName = props.FileName ?? null;
            const typeName = uploadName && uploadName.includes('.') ? uploadName.split('.').pop() : null;

            return {
                Media: props.Media ?? null,
                MediaContext: props.MediaContext ?? null,
                IDEmployee: props.IDEmployee ?? null,
                IDHiringDocumentStage: props.IDHiringDocumentStage ?? null,
                State: props.State ?? null,
                UploadName: uploadName,
                TypeName: typeName
            };
        });

        return newList;
    };

    return (
        <div className="row">
            <div className="col-md-6">
                <SelectModalityNewSer disable={props.NotModifyHiringModality} idSelector={response.IDHiringModality} onChange={(e: any) => { setResponse({ ...response, IDHiringModality: e }) }}></SelectModalityNewSer>
            </div>
            <div className="col-md-6">
                <SelectHiringModalityStage idHiringModality={response.IDHiringModality} idSelector={response.IDHiringModalityStage} onChange={(e) => { setResponse({ ...response, IDHiringModalityStage: e }) }} label="Estapa de Modalidad" />
            </div>
            {lista.length > 0 ?
                <div className="col-md-12 mt-2">
                    <div className="list-group " style={{ maxHeight: "52vh", overflow: "auto" }}>
                        {lista.map((data: any, index: number) => {
                            const item = data.DataBeanProperties;

                            const reqId = Number(item.IDHiringModalityDocument);
                            const uploaded = uploadedByRequirementId.get(reqId);
                            const uploadedProps = uploaded?.DataBeanProperties;

                            return (
                                <div key={index} className="list-group-item d-flex justify-content-between align-items-center" >
                                    <span style={{ width: "80%", overflow: "hidden", textWrap: "nowrap" }}>
                                        <i className="ri-article-line fs-2 align-middle me-2 cursor"></i>
                                        {index + 1} - {item.NameType}
                                        <span className={`badge mx-2 ${uploaded ? "bg-success" : `${item.Optional ? "bg-info" : "bg-warning"}`}`}>
                                            {uploaded ? "Cargado" : "Pendiente"}
                                        </span>
                                    </span>

                                    <button
                                        type="button"
                                        className="btn btn-md btn-link"
                                        style={{ textDecoration: "none" }}
                                        disabled={typeof (response.IDHiringModalityStage) !== "number"}
                                        onClick={(e) => {
                                            setBeanDoc({
                                                IDAdquisitionItem: beanItem.IDAdquisitionItem,
                                                IDAdquisitionContract: beanItem.IDAdquisitionContract,
                                                IDHiringModality: beanItem.IDHiringModality,
                                                IDHiringModalityStage: response.IDHiringModalityStage,
                                                IDHiringDocumentStage: item.IDHiringModalityDocument,
                                                IDEmployee: _single.getAccountID(),
                                                LastUpdate: _single.getCurrenDate(),
                                                State: 1,
                                                IDContractFiles: uploadedProps?.IDContractFiles,
                                                Media: uploadedProps?.Media,
                                                MediaContext: uploadedProps?.MediaContext,
                                                FileName: uploadedProps?.FileName,
                                            });
                                            modalAdd.open(`Cargar Documento de ${item.NameType}`);
                                        }}
                                    >
                                        <i className="ri-file-add-line"></i>
                                    </button>

                                    {uploaded && (
                                        <button
                                            type="button"
                                            className="btn btn-md btn-link"
                                            style={{ textDecoration: "none" }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                window.open(
                                                    fileService.getUrlFile(
                                                        uploadedProps.MediaContext,
                                                        uploadedProps.Media
                                                    ),
                                                    "_blank"
                                                );
                                            }}
                                        >
                                            <i className="ri-file-download-line"></i>
                                        </button>

                                    )}

                                    {uploaded && (
                                        <button
                                            type="button"
                                            className="btn btn-md btn-link text-danger"
                                            style={{ textDecoration: "none" }}
                                            onClick={(e) => {
                                                setBeanDoc({
                                                    IDAdquisitionItem: beanItem.IDAdquisitionItem,
                                                    IDAdquisitionContract: beanItem.IDAdquisitionContract,
                                                    IDHiringModality: beanItem.IDHiringModality,
                                                    IDHiringModalityStage: response.IDHiringModalityStage,
                                                    IDHiringDocumentStage: item.IDHiringModalityDocument,
                                                    IDEmployee: _single.getAccountID(),
                                                    LastUpdate: _single.getCurrenDate(),
                                                    State: uploadedProps?.State ?? 1,
                                                    IDContractFiles: uploadedProps?.IDContractFiles,
                                                    Media: uploadedProps?.Media,
                                                    MediaContext: uploadedProps?.MediaContext,
                                                    FileName: uploadedProps?.FileName,
                                                });
                                                modalDel.open(`Eliminar Documento de ${item.NameType}`);
                                            }}
                                        >
                                            ✕
                                        </button>
                                    )}
                                </div>
                            )
                        })}
                    </div>

                    <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} eventModal={() => { updateDocument() }}>
                        <div className="row">
                            <div className="col-md-12">
                                <FileInput directory="DocumentExpediente" label="Documento" Media={beanDoc?.Media} MediaContext={beanDoc?.MediaContext} onCreate={(e: any) => {
                                    setBeanDoc({ ...beanDoc, Media: e.Media, MediaContext: e.MediaContext, FileName: e.Name })
                                }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={() => { deleteDoc() }}>
                        <div className="row">
                            <div className="col-md-12">
                                ¿Eliminar documento {beanDoc?.FileName}?
                            </div>
                        </div>
                    </Modal>
                </div>
                :
                <div className="col-md-12">
                    <Alert children={`Sin Requisitos para cargar`} clase="info" />
                </div>
            }

            {!canContinue && (
                <div className="text-warning mt-2">
                    Debe cargar todos los documentos obligatorios para continuar.
                </div>
            )}


            <div className="col-md-12 mt-2">
                <BasicButton
                    eventClick={onExportMap}
                    disable={!canContinue || typeof (response.IDHiringModalityStage) !== "number"}
                    icon="ri-send-plane-line"
                    children={"Continuar"}
                />
            </div>
        </div>
    );
}